<template>
  <!-- 查询结果页 -->
  <div class="mainbox">
    <Head v-if="logo" :logo="logo"></Head>
    <van-tabs
      v-model="active"
      swipeable
      animated
      color="#1989fa"
      @change="change"
      v-if="fromtype==1 && isSearchHistory!=0" 
    >
      <van-tab v-for="(item,index) in picker" :key="index" :title="item">
      </van-tab>
    </van-tabs>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" head-height="120">
          <div class="cont">
            <div class="touch"></div>
            <div v-if="dataList.length>0" @touchmove.stop>
              <List :dataList="dataList" @func="handleItem(arguments)"  @checkArr="getCheck" 
              :checkedMark="checkedMark" @showTicket='showTicket' :isMerge='true'></List>
              <div class="replay" @click="handlePage" v-if="iscode == false">
                <div v-if="hasmore">
                  <div v-if="pageLoading">
                    <van-loading size="24px">加载中...</van-loading>
                  </div>
                  <div v-else>
                    <van-icon name="replay" />点击加载更多数据
                  </div>
                </div>
                <div v-else>暂无更多数据</div>
              </div>
            </div>
            <div v-else class="nodata">
              <van-loading
                size="24px"
                v-if="dataList.length==0 && loading && refreshing==false"
              >加载中...</van-loading>
              <div v-if="dataList.length==0 && !loading">暂无数据</div>
            </div>
          </div>
          <!-- 支付按钮 -->
          <van-button
            round
            block
            type="info"
            v-if="isPay &&  dataList.length>0"
            :disabled="usepay?false:true"
            @click="handlePay"
            class="btn"
          >支付</van-button>
          <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>
        </van-pull-refresh>
    <!-- 弹窗 -->
    <van-dialog v-model="showModel" title="收费项目明细">
      <div class="content">
        <div
          v-for="(item,index) in detailList"
          :key="index"
        >{{item.itemName}}:{{Number(item.actualAmt).toFixed(2)}}{{item.unit}}</div>
      </div>
    </van-dialog>
    <!-- 选择打印票据的缴款人弹窗 -->
    <van-dialog v-model="showSelectModel" title="选择开票单位" :before-close="beforeClose">
      <div class="paymentSelect">
        <van-radio-group v-model="selectPaymentUnit">
          <van-radio v-for="(item,index) in paymentUnitArr" :key="index" :name="item">{{item}}</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
    <van-dialog v-model="selectTicketDiglogVisible" title="查看电子票"  @close="closeTicket">
      <div class="paymentSelect">
        <van-radio-group v-model="chasePay" @change="changeTicketArr">
          <van-radio v-for="(item,index) in selectTicketArr" :key="index" :name="item.value">{{item.label}}</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
    <BillPhone
      :isShowDialog="isShowBillPhone"
      :isRefNotice="isRefNotice"
      :checkArr="checkArr"
      @payContinue="closeBillPhonePay"
      @closeDialog="closeDia"
    ></BillPhone>
    <div id="widget" />
  </div>
</template>

<script>
import Foot from "@/components/foot";
import Head from "@/components/head";
import List from "@/components/list";
import BillPhone from "@/components/billPhone"
import { Dialog, Notify, Toast } from "vant";
import { judgeVde } from "@/utils/publicJudge";
let loadedMineMapJs = false;

export default {
  components: {
    Foot,
    Head,
    List,
    BillPhone,
  },
  data() {
    return {
      refundItem:{},
      isRefundShow:false,
      selectItem:{},
      isRefNotice:false,
      isShowBillPhone:false,
      selectPaymentUnit: "",
      paymentUnitArr: [],
      showSelectModel: false,
      active: 0,
      idCard: "",
      paymentUnit: "",
      phone: "",
      payCode: "",
      bizNumber: "",
      type: 0,
      vde: "",
      dataList: [],
      isPay: true, //判断是否显示支付按钮
      bizId: "",
      sysType: "",
      sign: "",
      loading: true,
      usepay: true,
      mon: "",
      list: [], //温馨提示列表
      logo: "",
      picker: ["未缴费", "已缴费"],
      page: 1,
      limit: 5,
      total: 0,
      hasmore: true,
      pageLoading: false,
      iscode: false, // 是否通过扫码进入
      isSearchHistory: 0, //是否显示已缴费数据
      showModel: false,
      detailList: [],
      refreshing: false,
      showmon: "",
      checkedMark: "",
      payData: {},

      isWxmp:false,//判断是否在小程序内
      backQueryData:{ //小程序回调查询参数
        merchant_order_no:'',
        merchant_no:'',
      },
      selectRow:{},
      selectTicketDiglogVisible:false,
      selectTicketArr:[
        {label:'预收',value:'1'},
        {label:'结算',value:'2'},
      ],
      chasePay:'',
      ticketUrl:'',
      checkArr:[],//选中的数据
      isPaying:false,
      remitPayF:false,
      remitInfo:null,// 汇合缴费
      isShowDetail:false,
    };
  },
  created() {
     this.isWxmp = window.localStorage.getItem('isWxmp') == '1'?true:false
     this.initFrom()
     this.vde =this.$route.query.vde?this.$route.query.vde:''
    //判断vde
    judgeVde({ vde: this.vde }, this);
    if (this.$route.query.mon === undefined) {
      this.mon = "";
    } else {
      // 支付之后回调
      this.mon = this.$route.query.mon;
      this.showmon = this.$route.query.mon;
      this.picker = ["未缴费", "已缴费"];
      this.active = 1;
      this.type = 1;
    }
    this.idCard = this.$route.query.idCard?this.$route.query.idCard:'';
    this.paymentUnit = this.$route.query.paymentUnit?this.$route.query.paymentUnit:'';
    this.phone = this.$route.query.phone?this.$route.query.phone:'';
    this.payCode = this.$route.query.payCode?this.$route.query.payCode:'';
    this.bizNumber = this.$route.query.bizNumber?this.$route.query.bizNumber:'';
    this.bizId = this.$route.query.bizId?this.$route.query.bizId:'';
    this.sysType = this.$route.query.sysType?this.$route.query.sysType:'';
    this.sign = this.$route.query.sign?this.$route.query.sign:'';
    this.fromtype = this.$route.query.fromtype?this.$route.query.fromtype:'';
    if (this.fromtype == 1) {
        if (this.isWxmp) {
          // 小程序支付成功的回调
          if (window.localStorage.getItem('wxmpBack') == '1') {
            this.backQueryData.merchant_order_no = window.localStorage.getItem('merchant_order_no') 
            this.backQueryData.merchant_no = window.localStorage.getItem('merchant_no')
            this.getBackData()
          }else {
            this.getData(); //查询进入
          }
        }else {
            this.getData(); //查询进入
        }
    }
    if (this.fromtype == 2) {
      this.getQueryData(); //扫码进入
      this.checkedMark = this.bizId;
    }
    if (this.fromtype == 3) {
      this.type = this.$route.query.type;
      this.getNoticeQuery(); //扫码进入
    }

    this.getFootData();
    this.getHeadImg();
  },
  destroyed() {
    Toast.clear();
  },
  mounted() {
      setTimeout(()=>{
          if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
              document.addEventListener('WeixinJSBridgeReady', ready, false)
            } else {
              ready();
            }
          function  ready(){
              if (window.__wxjs_environment === 'miniprogram') {
                WeixinJSBridge.on('onPageStateChange', function(res) {
                  // todo 查询订单支付状态 等逻辑决定是否需要跳转页面
                  if (res.active === 'true' || res.active === true) {
                     window.localStorage.setItem('wxmpBack','1')
                     window.localStorage.setItem('isWxmp','1')
                    let num =  new Date().getTime()+Math.floor(Math.random())
                    let reslut = window.location.href.indexOf('nowTime');
                    if (reslut==-1) {
                        window.location.href = window.location.href+"&nowTime="+num
                      }else {
                        let str = window.location.href.slice(0, reslut);
                        window.location.href = window.location.href+"&nowTime="+num
                      }
                  }
                });
              }
        }

      },0)
  },
  methods: {
    refundChange(item){
      this.refundItem=item;
      this.isRefundShow=true;
    },
    saveRefund(){

    },
    showDetail(item) {
      this.selectItem = item;
      this.isShowDetail = true;
    },
    closeDialog() {
      this.selectItem = {};
      this.isShowDetail = false;
    },
    closeDia(){
       this.isShowBillPhone=false;  
       this.usepay = true;
    },
     // 初始化来源，判断是否在微信小程序内
    initFrom() {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
              this.isWxmp = true
            } else {
            }
          })
      }else{
      }
    },
    // 子传父的参数（用于弹窗）
    handleItem(data) {
      this.showModel = data[0];
      this.detailList = data[1];
    },
    // 下拉刷新
    async onRefresh() {
      this.page = 1;
      this.limit = 5;
      this.dataList = [];
      this.loading = true;

      if (this.$route.query.fromtype == 1) {
        await this.getData();
      }
      if (this.$route.query.fromtype == 2) {
        await this.getQueryData();
      }
      if (this.$route.query.fromtype == 3) {
        await this.getNoticeQuery();
      }
      this.hasmore = true;
      this.refreshing = false;
      await Toast("刷新成功");
    },

    // 切换导航栏
    change(e) {
      this.dataList = [];
      this.page = 1;
      this.limit = 5;
      if (e == 0) {
        this.type = 0;
        this.mon = "";
      } else if (e == 1) {
        // this.type = 9;
        // this.mon = "";
        this.type = 1;
        if (this.showmon && this.isSearchHistory == 1) {
          this.mon = "";
        } else if (this.showmon && this.isSearchHistory == 0) {
          this.mon = this.showmon;
        }
      } 
      this.hasmore = true;
      this.getData();
    },
    // 获取头像
    getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url:'/webPortal/websitConfig',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code == 1000 && res.data.result.logoUrlLogin) {
          this.logo = res.data.result.logoUrlLogin;
          sessionStorage.setItem("title", res.data.result.websitTitle);
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" });
        } else {
          this.logo = require("../assets/img/logo.png");
        }
      })
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 4,
      };
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code != 1000) {
            //this.$router.push({ path: "/404" });
          } else {
            this.list = res.data.result;
            if (this.iscode == false) {
              this.isSearchHistory = res.data.result.isSearchHistory;

            }
          }
      })
    },
    // 分页
    handlePage() {
      this.pageLoading = true;
      if (this.dataList.length < this.total) {
        this.page++;
        this.getData();
      } else {
        setTimeout(() => {
          this.pageLoading = false;
          this.hasmore = false;
        }, 500);
      }
    },
    // 从查询页进来的
    getData() {
      if (this.page == 1) {
        this.dataList = [];
        this.loading = true;
      } else {
        this.pageLoading = true;
      }
      let data = {
        idCard: this.idCard,
        paymentUnit: this.paymentUnit,
        phone: this.phone,
        payCode: this.payCode,
        bizNumber: this.bizNumber,
        confirmType: this.type,
        vde: this.vde,
        mon: this.mon,
        page: this.page,
        limit: this.limit,
      };
      // 小程序新传的参数
      if (this.isWxmp) {
        data.openid = this.$route.query.openid?this.$route.query.openid:'';
        data.userId = this.$route.query.userId?this.$route.query.userId:'';
        data.paymentName = this.$route.query.paymentName?this.$route.query.paymentName:'';
      }
      return new Promise((resolve) => {
        this.request({
          url:'/mobile/queryData',
          method:'get',
          params:data
        }).then((res)=>{
            this.loading = false;
            this.pageLoading = false;
            if (res.data.code == 1000) {
              if (res.data.result != null) {
                this.dataList = this.dataList.concat(res.data.result.list);
                this.total = res.data.result.total;
                this.isPay = this.dataList.some((val) => {
                  return val.isConfirm != 1;
                });
              }
              this.$forceUpdate();
            }
            resolve();
        })
      });
    },
    // 扫码进入的
    getQueryData() {
      this.iscode = true;
      let data = {
        bizId: this.bizId,
        sysType: this.sysType,
        sign: this.sign,
        vde: this.vde,
      };
      this.request({
        url:'/mobile/qrcodeQueryData',
        method:'get',
        params:data
      }).then((res)=>{
          this.loading = false;
          if (res.data.code == 1000) {
            this.dataList = res.data.result;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }
      })
    },
    //告知单扫描进入
    getNoticeQuery() {
      this.iscode = true;
      let data = {
        bizId: this.bizId,
        vde: this.vde,
        confirmType: this.type,
      };
      this.request({
        url:'/mobile/queryData',
        method:'get',
        params:data
      }).then((res)=>{
          this.loading = false;
          this.pageLoading = false;
          if (res.data.code == 1000) {
            if (res.data.result != null) {
              this.dataList = this.dataList.concat(res.data.result.list);
              this.total = res.data.result.total;
              this.isPay = this.dataList.some((val) => {
                return val.isConfirm != 1;
              });
            }
            this.$forceUpdate();
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }
      })
    },
    beforeClose(action, done, data) {
      if (this.selectPaymentUnit == "") {
        Notify("请选择需要开票的单位");
        done(false);
      } else {
        this.payData.payerName = this.selectPaymentUnit;
        this.remitPayF=false; //  现在把flag设置为false，也会调用beforePay
        this.initPayType(this.checkArr[0]);
        // this.beforePay(); 以前关闭窗口调的 beforePay
        done();
      }
    },
    getCheck(checkArr) {
      this.checkArr = checkArr
    },
    handlePay() {
      let bizDatas = [];
      let payAmt = 0;
      let selectItem = {}
      let bool = this.dataList.some((val) => {
        return val.checked;
      });
         //是否为汇缴合并支付
      let checkLen = this.checkArr.length;
      let remitPayFlag = false;
      this.isPaying = false;
      if(checkLen>1 ){
         remitPayFlag =  this.checkArr.some((val)=>{
          return val.merchantType == '001' || val.merchantType == '002' || val.merchantType == '003'
        })
      }else if(checkLen==1){
        if(this.checkArr[0].merchantType  == '001' || this.checkArr[0].merchantType == '002' || this.checkArr[0].merchantType == '003'){
          remitPayFlag = true;
        }
      }
      if (bool) {
        this.remitPayF=remitPayFlag;
        this.usepay = false;
        if (this.showSelectModel == false) {
          this.payData.payerName = "";
          if(remitPayFlag){
            //是汇缴合并支付
            this.checkArr.forEach((val)=>{
              let arr = {
                   bizId:val.uId,
                  sysType:val.sysType,
                  deptId:val.deptId,
              }
              bizDatas.push(arr);

              payAmt += Number(val.paymentTotal);
              if (val.paymentUnit && val.extraPaymentUnit) {
                  this.paymentUnitArr = [val.paymentUnit, val.extraPaymentUnit];
                  this.showSelectModel = true;
                }
              if (val.isConfirm == '9') { //支付中提示
                this.isPaying = true;
              }
            })
             let info = {
                bizDatas: bizDatas,
                payAmt: payAmt.toFixed(2),
                deviceType: "phone",
              };
               if(this.isWxmp) {
                  info.deviceType = 'miniProgramH5';
                  info.userId = selectItem.userId;
                  info.openid = selectItem.openid;
                  info.paymentName = selectItem.paymentName;
                }
               this.remitInfo=info;
            // this.remitPay(info);
          }else{
            //否汇缴合并支付
            this.dataList.forEach((val) => {
              if (val.checked == true) {
                selectItem = val
                if (val.paymentUnit&& val.extraPaymentUnit) {
                  this.paymentUnitArr = [val.paymentUnit, val.extraPaymentUnit];
                  this.showSelectModel = true;
                }
                if (val.isConfirm == '9') {
                  this.isPaying = true;
                }
              }
            });
            this.payData = {
              noticeNo:selectItem.noticeNo,
              sysType: selectItem.sysType,
              payAmt: selectItem.paymentTotal,
              deviceType: "phone",
            };
            // 微信小程序参数
            if(this.isWxmp) {
              this.payData.deviceType = 'miniProgramH5'
              this.$set(this.payData,'userId',selectItem.userId)
              this.$set(this.payData,'openid',selectItem.openid)
              this.$set(this.payData,'paymentName',selectItem.paymentName)
            }
            // this.beforePay();
          }
          if(!this.showSelectModel){
            this.initPayType(this.checkArr[0])
          }
        }
      } else {
        Dialog.alert({
          title: "提示",
          message: "请选择需要缴费的项目",
        }).then(() => {});
      }
    },
    initPayType(payData) {
      // 5000001411001000009
      if(payData.isPrompt){
        this.isRefNotice=true;
      }else{
        this.isRefNotice=false;
      }
      // &&this.isRefNotice==false
      if (this.isRefNotice==false) {
        this.handlePayContinue(); //走原流程支付
      }else { 
        // 弹窗弹出信息
        this.isShowBillPhone = true;
      }
    },
     closeBillPhonePay() {
      //  录入手机号码和缴款人类型后，继续调支付
      this.isShowBillPhone = false;
      this.handlePayContinue()
    },
    handlePayContinue(){
      if (this.remitPayF) {
        //是汇缴合并支付
        this.remitPay(this.remitInfo)
      } else {
        //否汇缴合并支付
        this.beforePay()
      }
    },
    beforePay() {
      if (this.isPaying) {
        Dialog.confirm({
          title: "提示",
          message: '选中的数据存在支付中数据，是否继续支付？',
          confirmButtonText:'是',
          cancelButtonText:'否'
        })
          .then(() => {
            this.pay(this.payData);
          })
          .catch(() => {
            window.location.reload();
            this.usepay = true;
          });
      } else {
        this.pay(this.payData);
      }
    },
    pay(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/epay/pay_init',
        method:'get',
        params:data
      }).then((res)=>{
          if (res.data.code == 1000) {
            //未加载成功
            this.backQueryData.merchant_order_no = res.data.result.merchant_order_no
            this.backQueryData.merchant_no = res.data.result.merchant_no
            window.localStorage.setItem('merchant_order_no',this.backQueryData.merchant_order_no)
            window.localStorage.setItem('merchant_no',this.backQueryData.merchant_no)
            if (!loadedMineMapJs) {
              this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
                loadedMineMapJs = true;
                this.otherPay(res.data.result);
              });
              // 已经加载成功
            } else {
              this.otherPay(res.data.result);
            }
          } else {
            Toast.clear();
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {
              this.usepay = true;
              window.location.reload();
            });
          }
      })
    },
    remitPay (data) {
      if (this.isPaying) {
        Dialog.confirm({
          title: '提示',
          message: '选中的数据存在支付中数据，是否继续支付？',
          confirmButtonText:'是',
          cancelButtonText:'否'
        })
        .then(() => {
          this.remitPayRequest(data)
        })
        .catch(() => {
           this.usepay = true;
            window.location.reload();

        });
      }else {
        this.remitPayRequest(data)
      }
    },
    remitPayRequest(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/merger/remit_pay',
        method:'post',
        data:data
      }).then((res)=>{
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          }).then(() => {
            this.usepay = true;
            window.location.reload();

          });
        }

      })
    },

    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      // 微信小程序中，多加几个参数
      if (this.isWxmp) {
        this.$set(obj,'paymentName',res.paymentName)
        this.$set(obj,'itemNameSet',res.itemNameSet)
      }
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
          that.usepay = true;
        }
      }, 100);
    },
    // 小程序支付成功后回调
  getBackData() {
        this.picker = ["未缴费", "已缴费"];
        this.active = 2;
        this.type = 1;
        this.page = 1
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url:'/epay/order_query',
          method:'post',
          data: this.backQueryDat
        }).then((res)=>{
            this.loading = false
            if (res.data.code == 1000) {
                this.mon = res.data.result.merchant_order_no
                window.localStorage.setItem('wxmpBack','')
                window.localStorage.setItem('merchant_order_no','')
                window.localStorage.setItem('merchant_no','')
                this.getData()
            }
        })
  },
  showTicket(item) {
    this.selectRow = item;
    this.selectTicketDiglogVisible = true;
  },
  changeTicketArr(val) {
    if (val == '1') {
      this.ticketUrl = '/pay/showETicket';
    }else {
      this.ticketUrl = '/pay/showETicketGy';
    }
    this.getTicket()
  },
  closeTicket() {
    this.chasePay = '';
  },
  getTicket() {
         let data = {
						bizId:this.selectRow.uId,
						noticeNo:this.selectRow.noticeNo,
						sysType:this.selectRow.sysType,
					}
				this.request({
					baseURL: process.env.VUE_APP_PAY_URL,
					url:this.ticketUrl,
					method:'get',
					params:data
				}).then((res)=>{
					if (res.data.code == 1000) {
            this.selectTicketDiglogVisible = false;
						window.location.href=res.data.message;
					}else {
						 Toast(res.data.message);
					}
				})
			},
  },
};

</script>

<style lang="scss" scoped>
.mainbox {
  padding: 0 2vw;
  box-sizing: border-box;
}
.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #888;
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #999;
    position: relative;
    z-index: 11;
  }
  .touch {
    height: 30vh;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
}
.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}
.btn {
  margin: 20px 0;
}
.paymentSelect {
  padding: 20px;
  text-align: center;
  .van-radio {
    margin: 10px 0;
  }
}




</style>
